export interface WallColor {
  readonly name: string
  readonly color: string
}

const WallColors: readonly WallColor[] = [
  { name: 'Default', color: 'rgb(255, 255, 255)' },
  { name: 'White', color: 'rgb(229, 228, 219)' },
  { name: 'Alabaster', color: 'rgb(242, 240, 230)' },
  { name: 'Sea Fog', color: 'rgb(223, 221, 214)' },
  { name: 'Double Alabaster', color: 'rgb(243, 243, 237)' },
  { name: 'Off White', color: 'rgb(240, 238, 234)' },
  { name: 'White Pointer', color: 'rgb(218, 214, 204)' },
  { name: 'Quarter Tea', color: 'rgb(224, 218, 208)' },
  { name: 'Half Tea', color: 'rgb(206, 198, 181)' },
  { name: 'Rice Cake', color: 'rgb(239, 236, 222)' },
  { name: 'Quarter Off White', color: 'rgb(242, 241, 237)' },
  { name: 'Half Alabaster', color: 'rgb(240, 238, 235)' },
  { name: 'Half Sea Fog', color: 'rgb(239, 238, 231)' },
  { name: 'Half White Pointer', color: 'rgb(226, 225, 219)' },
  { name: 'Pitch Black', color: 'rgb(44, 43, 44)' },
  { name: 'Merino', color: 'rgb(225, 219, 208)' },
  { name: 'Quarter Spanish White', color: 'rgb(235, 226, 210)' },
  { name: 'Half Spanish White', color: 'rgb(230, 219, 199)' },
  { name: 'Black', color: 'rgb(30, 30, 30)' },
  { name: 'Half Rice Cake', color: 'rgb(242, 240, 231)' },
  { name: 'Eighth Thorndon Cream', color: 'rgb(240, 238, 229)' },
  { name: 'Moby', color: 'rgb(153, 188, 199)' },
  { name: 'Raindance', color: 'rgb(167, 190, 195)' },
  { name: 'Lazy River', color: 'rgb(121, 154, 170)' },
  { name: 'Safehaven', color: 'rgb(81, 97, 107)' },
  { name: 'Bismark', color: 'rgb(90, 131, 142)' },
  { name: 'Wishing Well', color: 'rgb(47, 83, 108)' },
  { name: 'Moana', color: 'rgb(0, 144, 186)' },
  { name: 'Herring', color: 'rgb(169, 86, 81)' },
  { name: 'Pohutukawa', color: 'rgb(137, 60, 63)' },
  { name: 'Poppy', color: 'rgb(178, 57, 53)' },
  { name: 'Salsa', color: 'rgb(129, 61, 63)' },
  { name: 'Code Red', color: 'rgb(155, 58, 67)' },
  { name: 'Courage', color: 'rgb(100, 66, 68)' },
  { name: 'Candy Floss', color: 'rgb(195, 66, 73)' },
  { name: 'Green Smoke', color: 'rgb(179, 178, 129)' },
  { name: 'Away We Go', color: 'rgb(96, 148, 114)' },
  { name: 'Peace', color: 'rgb(164, 169, 155)' },
  { name: 'New Leaf', color: 'rgb(130, 124, 89)' },
  { name: 'Family Tree', color: 'rgb(59, 79, 73)' },
  { name: 'Atlas', color: 'rgb(51, 82, 82)' },
  { name: 'Nourish', color: 'rgb(166, 183, 156)' },
  { name: 'Thumbs Up', color: 'rgb(222, 172, 89)' },
  { name: 'I Dare You', color: 'rgb(247, 177, 30)' },
  { name: 'Hive', color: 'rgb(230, 184, 36)' },
  { name: 'Moonlight', color: 'rgb(242, 226, 193)' },
  { name: 'Chorus Line', color: 'rgb(254, 215, 126)' },
  { name: 'Wild Thing', color: 'rgb(255, 210, 96)' },
  { name: 'Turbo', color: 'rgb(255, 200, 11)' },
  { name: 'White', color: 'rgb(245, 245, 242)' },
  { name: 'Duck Egg Blue', color: 'rgb(183, 193, 188)' },
  { name: 'Half Innocence', color: 'rgb(138, 151, 148)' },
  { name: 'Half Merino', color: 'rgb(236, 234, 226)' },
  { name: 'Blue Night', color: 'rgb(31, 38, 59)' },
  { name: 'Half Surrender', color: 'rgb(202, 204, 204)' },
  { name: 'Stack', color: 'rgb(133, 136, 133)' },
  { name: 'Quarter Stack', color: 'rgb(175, 178, 175)' },
  { name: 'Quarter Silver Chalice', color: 'rgb(199, 200, 198)' },
  { name: 'Parchment', color: 'rgb(208, 200, 176)' },
  { name: 'Eighth Parchment', color: 'rgb(237, 233, 220)' },
  { name: 'Highball', color: 'rgb(146, 140, 60)' },
  { name: 'Vesuvius', color: 'rgb(168, 85, 51)' },
  { name: 'Half Baltic Sea', color: 'rgb(86, 86, 87)' },
  { name: 'Quarter Sisal', color: 'rgb(228, 218, 196)' },
  { name: 'Smashing', color: 'rgb(173, 0, 32)' },
  { name: 'Triple Concrete', color: 'rgb(183, 182, 181)' },
  { name: 'Double Stack', color: 'rgb(111, 113, 110)' },
  { name: 'Fuscous Grey', color: 'rgb(60, 59, 60)' },
  { name: 'Nocturnal', color: 'rgb(47, 49, 49)' },
  { name: 'Native', color: 'rgb(161, 144, 75)' },
  { name: 'Titania Quarter', color: 'rgb(233, 230, 218)' },
  { name: 'Paddock', color: 'rgb(102, 113, 86)' },
  { name: 'Secrets', color: 'rgb(198, 202, 187)' },
  { name: 'Half Evolution', color: 'rgb(130, 125, 107)' },
  { name: 'Templestone', color: 'rgb(107, 114, 104)' },
  { name: 'Silver Aluminium', color: 'rgb(158, 160, 161)' },
  { name: 'Coast', color: 'rgb(36, 52, 66)' },
  { name: 'Fugitive', color: 'rgb(182, 57, 58)' },
  { name: 'Inside back', color: 'rgb(132, 142, 136)' },
  { name: 'Foundry', color: 'rgb(44, 46, 50)' },
  { name: 'Whirl wind', color: 'rgb(107, 140, 146)' },
  { name: 'Half Bison Hide', color: 'rgb(199, 189, 171)' },
  { name: 'Half Villa White', color: 'rgb(243, 238, 223)' },
  { name: 'Diesel', color: 'rgb(50, 44, 43)' },
  { name: 'Sorrento', color: 'rgb(154, 176, 172)' },
  { name: 'Double Bison Hide', color: 'rgb(161, 151, 129)' },
  { name: 'Putty', color: 'rgb(205, 174, 112)' },
  { name: 'Quarter Bison Hide', color: 'rgb(208, 202, 186)' },
]

export default WallColors
